export const promoConstants = {
    ADD_PROMO_REQUEST:              'ADD_PROMO_REQUEST',
    ADD_PROMO_SUCCESS:              'ADD_PROMO_SUCCESS',
    ADD_PROMO_FAILURE:              'ADD_PROMO_FAILURE',

    GET_PROMO_REQUEST:              'GET_PROMO_REQUEST',
    GET_PROMO_SUCCESS:              'GET_PROMO_SUCCESS',
    GET_PROMO_FAILURE:              'GET_PROMO_FAILURE',

    DELETE_PROMO_REQUEST:            'DELETE_PROMO_REQUEST',
    DELETE_PROMO_SUCCESS:            'DELETE_PROMO_SUCCESS',
    DELETE_PROMO_FAILURE:            'DELETE_PROMO_FAILURE',

    GET_PROMODETAIL_REQUEST:         'GET_PROMODETAIL_REQUEST',
    GET_PROMODETAIL_SUCCESS:         'GET_PROMODETAIL_SUCCESS',
    GET_PROMODETAIL_FAILURE:          'GET_PROMODETAIL_FAILURE',

    UPDATE_PROMO_REQUEST:        'UPDATE_PROMO_REQUEST',
    UPDATE_PROMO_SUCCESS:        'UPDATE_PROMO_SUCCESS',
    UPDATE_PROMO_FAILURE:        'UPDATE_PROMO_FAILURE'
}


// WEBPACK FOOTER //
// ./src/app/redux/constants/promoConstants.js